<template>
  <div class="text-center primary--text">

    <div class="d-flex flex-column justify-space-between align-center">
      <v-img aspect-ratio="1" width="100%" max-width="200px" contain src="@/assets/Herz.svg"></v-img>
      <h1 class="display-1 font-weight-bold ma-5 white--text">Thank you</h1>
    </div>

    <div class="my-2">Thank you for sharing your message with the <span class="font-italic">Religions for
      Peace</span> family and the participants of the <span class="font-italic">"Conference of the World Council of Religious Leaders on Faith and
Diplomacy: Generations in Dialogue"</span></div>
    <div>
      <a href="https://ringforpeace.org/">Go back to Assembly Homepage</a>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex';

export default {
  name: 'StepThankyou',
  components: {
  },
  data: () => ({
  }),
  // ...
  computed: {
    ...mapState({
    })
  },
  methods: {


  }
}
</script>
